import { Fragment, ReactNode, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Menu,
    Transition,
} from "@headlessui/react";
import { toast } from 'react-toastify';
import { DeleteCertificate } from '../../../api/Certificates/DeleteCertificate';
import DeleteModal from '../../Shared/DeleteModal';

const CertificateDropdown = ({ children, certificateId }: { children?: ReactNode, certificateId: string; }) => {

    const [isMCQOpen, setIsMCQOpen] = useState(false);

    const handleDeleteCertificate = async (id: string) => {
        await DeleteCertificate(id);
        toast.success("Topic deleted successfully");
    };

    return (
        <div className="relative ">
            <Menu as="div" className="relative inline-block">
                <div>
                    <Menu.Button className="inline-flex w-full justify-center  focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75">
                        {children}
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className="absolute md:-top-40 md:right-0 right-5 mt-2 w-[221px] origin-top-right divide-y divide-gray-100 rounded-[7px] border-slate bg-white border border-opacity-20  backdrop-blur-[7.5px] bg-hayak_gray bg-opacity-80 text-left shadow-lg ring-1  -top-4 py-6 px-5 ring-black/5 focus:outline-none z-50 text-primary font-medium text-lg">
                        <div className=' flex flex-col gap-3'>
                            <Menu.Item>
                                <Link to={`add-topic/${certificateId}`}>Add Topic</Link>
                            </Menu.Item>
                            <Menu.Item>
                                <Link to={`add-mockup/${certificateId}`}>Add Mockup Exam</Link>
                            </Menu.Item>

                            <Menu.Item>
                                <Link to={`edit-certificate/${certificateId}`}>Edit Certificate</Link>
                            </Menu.Item>
                            <Menu.Item>
                                <Link className='text-left text-red-700' to={`delete-topic/${certificateId}`}>Delete Topic</Link>
                            </Menu.Item>
                            <Menu.Item>
                                <Link className='text-left text-red-700' to={`delete-mockups/${certificateId}`}>Delete Mockups</Link>
                            </Menu.Item>
                            <button className='text-left text-red-700'
                                onClick={() => {
                                    setIsMCQOpen(true);
                                }}
                            >Delete Certificate</button>
                            <DeleteModal
                                isOpen={isMCQOpen}
                                setIsOpen={setIsMCQOpen}
                                mutationFn={() => handleDeleteCertificate(certificateId!)}
                                itemId={certificateId!}
                                queryKey="certificates"
                            />

                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    )
}

export default CertificateDropdown

